var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.943 9.78064C14.7637 8.72273 17.0017 8.74122 18.8053 9.82908C20.5912 10.9391 21.6766 12.9201 21.6665 15.0512C21.625 17.1683 20.4611 19.1583 19.0062 20.6967C18.1665 21.5887 17.2272 22.3774 16.2074 23.0467C16.1023 23.1074 15.9873 23.1481 15.8679 23.1667C15.753 23.1618 15.6411 23.1278 15.5423 23.0679C13.9854 22.0621 12.6194 20.7784 11.5103 19.2783C10.5822 18.0261 10.0549 16.5133 10 14.9453C9.9988 12.8102 11.1223 10.8386 12.943 9.78064ZM13.994 15.8281C14.3002 16.5832 15.0231 17.0757 15.8252 17.0757C16.3506 17.0795 16.8557 16.869 17.2278 16.4912C17.6 16.1134 17.8084 15.5997 17.8065 15.0645C17.8093 14.2475 17.3284 13.5094 16.5882 13.1948C15.8481 12.8802 14.9947 13.0511 14.4266 13.6278C13.8585 14.2044 13.6877 15.0731 13.994 15.8281Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.9987 24.3327C18.2999 24.3327 20.1654 23.9596 20.1654 23.4993C20.1654 23.0391 18.2999 22.666 15.9987 22.666C13.6975 22.666 11.832 23.0391 11.832 23.4993C11.832 23.9596 13.6975 24.3327 15.9987 24.3327Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.67276100c5e46f4f3fd7a179248d54f5.svg";
export { ForwardRef as ReactComponent };